import { request } from "../../httpClient";

export const deleteVehicleRequest = async (id) => {
  const res = await request({
    path: "vehicle/delete",
    method: "POST",
    body: JSON.stringify({ id: id }),
  });
  return res;
};
